<script setup lang="ts">
import { onMounted } from 'vue'
import { useAppInit } from '@/composables/app/useAppInit'
import { useGlobalServerErrorToast } from '@/composables/app/useGlobalServerErrorToast'

const { locale } = useI18n()
const { initializeApp } = useAppInit()
const { isVisible: showGlobalErrorToast, message: globalErrorMessage, onClose: onGlobalErrorToastClose } = useGlobalServerErrorToast()

useHead({
  htmlAttrs: {
    lang: locale
  },
  link: [
    {
      rel: 'stylesheet',
      href: 'https://fonts.googleapis.com/css2?family=Inter+Tight:ital,wght@0,100..900;1,100..900&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap',
      media: 'print',
      onload: "this.media='all'"
    },
    {
      rel: 'stylesheet',
      href: 'https://fonts.googleapis.com/css2?family=PT+Sans:wght@400;700&display=swap',
      media: 'print',
      onload: "this.media='all'"
    },
    { rel: 'icon', type: 'image/png', href: '/assets/images/common/logo/favicon-icon.png' }
  ]
})

onMounted(() => {
  initializeApp()
})
</script>
<template>
  <NuxtLoadingIndicator />
  <UIToastError v-model="showGlobalErrorToast"
                :message="globalErrorMessage"
                :show-close="true"
                :auto-close="20000"
                @update:model-value="onGlobalErrorToastClose" />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
